import script from "./ImportDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImportDialog.vue?vue&type=script&setup=true&lang=ts"

import "./ImportDialog.vue?vue&type=style&index=0&id=5b0a8c44&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b0a8c44"]])